export interface ParticipationRateEntity {
    id: number
    shareType: string | null,
    priority: number | null,
    consortiumCode: string | null,
    vesselCode: string | null,
    voyageCode: string | null,
    serviceCode: string | null,
    soa: string | null,
    etd: Date | null,
    etb: Date | null,
    cntrStatus: string | null,
    activeInd: string | null,
    subChargeType: string | null,

    [key: string]: string | number | Date | null | undefined
}

export const EMPTY_PARTICIPATION_RATE_ENTITY: ParticipationRateEntity = {
    id: 0,
    shareType: null,
    priority: 0,
    consortiumCode: '',
    vesselCode: null,
    voyageCode: null,
    serviceCode: null,
    soa: null,
    etd: null,
    etb: null,
    cntrStatus: '',
    subChargeType: null,
    activeInd: "Y"
}

